import React, { } from "react";

import { Row, Col } from "react-bootstrap";

import { observer } from "mobx-react";

import {
  BottomsheetDropdown
} from "../../../../../components";

// import "../../../../optimization-card/family-collapse-view.css";

const WealthUltima = ({ form, data }) => {

  return (
    <React.Fragment>
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12 mt-3"> */}
        {/* <div className="mb-2 font-size-12 font-weight-light total-premium-container-heading">
            {form.$("policy-term").label}
          </div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.options}
          value={form.$("policy-term").value}
          onSelect={form.$("policy-term").onChange}
        />
        {/* </Col> */}
      </div>
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12 mt-3"> */}
        {/* <div className="mb-2 font-size-12 font-weight-light total-premium-container-heading">
            {form.$("premium-term").label}
          </div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("premium-term").label}
          menuList={form.$("premium-term").extra.options}
          value={form.$("premium-term").value}
          onSelect={form.$("premium-term").onChange}
        />
        {/* </Col> */}
      </div>
    </React.Fragment>
  );
};

export default observer(WealthUltima);
